import { useSurveyQuery } from "../../../../../api/surveys/useSurveyQuery";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../services/UINotificationService";
import { extractApiError } from "../../../../../utilities/api";
import { getPathParams } from "../utilities";

export const useSurvey = () => {
  const { surveyId } = getPathParams();

  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "survey",
  });

  const { data, isLoading, isError } = useSurveyQuery({
    payload: {
      id: surveyId,
    },
    options: {
      enabled: Boolean(surveyId),
      onError: (res) => {
        const message = extractApiError(res);
        uiNotification.error(t([`error.${message}`, "error.fetch"]));
      },
    },
  });

  return {
    data,
    isLoading,
    isError,
  };
};
